import React from 'react';
import { Translate } from 'react-redux-i18n';
import { getUnique } from './../../helpers/Common';

class VolumeInfo extends React.Component {
  renderItem = (label, value, currency, key) => {
    return (
      <div className="item-total-volume mt-1" key={getUnique() + key}>
        <Translate value={label} />
        <span>{value}</span>
        &nbsp;
        <Translate value={currency} />
      </div>
    );
  };
  render() {
    const { list } = this.props;

    return list.map(({ label, value, currency = '' }, index) => {
      return this.renderItem(label, value, currency, index);
    });
  }
}

export default VolumeInfo;
